<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Reporte descarga de boleta</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col> 
                    <vs-col sm="12" lg="3">
                        <label for="programa" class="pl-3 mr-1 labelInput">Programa</label>
                        <form autocomplete="off">
                            <vs-select filter :loading="loadingPrograma" id="programa" placeholder="Programa" v-model="programa"  :disabled="!programas.length" class="pt-0" :key="programasId">
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="grado" class="pl-3 mr-1 labelInput">Grado</label>
                        <form autocomplete="off">
                            <div style="position: relative">
                                <vs-select filter :loading="loadingGrado" id="grado" placeholder="Grado" v-model="grado"  :disabled="grupoAdmin != '' || grupo != '' || !grados.length" class="pt-0" :key="gradosId">
                                    <template #message-danger v-if="errorFields.includes('grado')">
                                        Requerido
                                    </template>
                                    <vs-option v-for="option in grados" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </vs-select>
                            </div>
                            <div v-if="grado !== ''" @click="grado = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="grupo-academico" class="pl-3 mr-1 labelInput">Grupo Académico</label>
                        <form autocomplete="off">
                            <div style="position: relative">
                                <vs-select filter :disabled="grupoAdmin != '' || grado != '' || !grupos.length" :loading="loadingGrupo" id="grupo-academico" placeholder="Grupo Académico" v-model="grupo" class="pt-0" :key="gruposId">
                                    <template #message-danger v-if="errorFields.includes('grupo')">
                                        Requerido
                                    </template>
                                    <vs-option v-for="option in grupos" :key="option.id"  :label="option.nombre" :value="option.bloque_academico_id">
                                        {{option.nombre}}
                                    </vs-option>
                                </vs-select>
                            </div>
                            <div v-if="grupo !== ''" @click="grupo = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="grupo" class="labelInput">
                                Grupo Administrativo
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    :disabled="grupo != '' || grado != '' || !gruposAdmin.length"
                                    :loading="loadingGrupoAdmin"
                                    filter
                                    class="pt-0"
                                    id="grupo"
                                    placeholder="Seleccionar grupo administrativo"
                                    :key="gruposAdminId"
                                    v-model="grupoAdmin">
                                    <template #message-danger v-if="errorFields.includes('grupoAdmin')">
                                        Requerido
                                    </template>
                                    <vs-option v-for="option in gruposAdmin" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </vs-select>
                            </div>
                            <div v-if="grupoAdmin !== ''" @click="grupoAdmin = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col>
                        <vs-button
                            class="ml-auto"
                            @click="getInfoBoletas('buscar')"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <tabla-descarga :users="users" :institucion="institucion" :filtros="filtros" :nombreArchivo="nombreArchivo" @refresTable="getInfoBoletas" :personaRol="personaRol" :nivel="nivel"></tabla-descarga>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import cobranza from '../../../../api/requests/cobranza-persona'
import catalogos from '../../../../api/requests/catalogos.js'
import TablaDescarga from './tabla-descarga.vue'
export default {
    props:[
        'personaRol'
    ],
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            programa: '',
            programas: [],
            programasId:(new Date()).getTime(),
            nivel: '',
            loadingPrograma: false,
            grado: '',
            grados: [],
            gradosId:(new Date()).getTime(),
            loadingGrado: false,
            loadingPeriodoCalculado: false,
            grupo: '',
            grupos: [],
            gruposId:(new Date()).getTime(),
            loadingGrupo: false,
            grupoAdmin: '',
            gruposAdmin: [],
            gruposAdminId:(new Date()).getTime(),
            loadingGrupoAdmin: false,
            errorFields: [],
            tache: false,
            users: [],
            filtros: [],
            nombreArchivo: '',
            institucionName: ''
        }
    },
    components:{
        TablaDescarga
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
            }
            catch{

            }
        },
        async getCicloEscolar() {
            this.loadingCiclo = true
            const { data: response } = await reportes.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },
        async getPrograma(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await catalogos.getProgramas(this.institucion)
                    this.programas = response
                    this.programasId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        
        async getNivelesAcademicos () {
            if (this.programa){
                let params = {
                programa: this.programa,
                institucion: this.institucion,
                }
                const { data: response } = await cobranza.getNivel(params) || {}
                const { opciones: niveles, default: val } = response || {}
                if (niveles){
                    this.listNivel =  Object.values(niveles)
                    this.nivel = val
                    this.nivelId = (new Date()).getTime()
                    
                }
            }
        },
        async getGradoAcademico(){
            if (this.programa) {
                try {
                    this.loadingGrado = true
                    const {data: response} = await reportes.getGradoAcademico(this.programa)
                    this.grados = response
                    this.gradosId = (new Date()).getTime()
                    this.loadingGrado = false
                } catch (error) {
                    
                }
            }
        },
        async getPeriodoCalificaciones(){
            if (this.programa) {
                try {
                    this.loadingPeriodo = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getPeriodoCalificaciones(params)
                    this.periodos = response
                    this.periodosId = (new Date()).getTime()
                    this.loadingPeriodo = false
                } catch (error) {
                    
                }
            }
        },
        async getPeriodoCalculados(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPeriodoCalculado = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                    }
                    const {data: response} = await reportes.getPeriodoCalculados(params)
                    this.periodos_calculados = response
                    this.periodosCalculadosId = (new Date()).getTime()
                    this.loadingPeriodoCalculado = false
                } catch (error) {
                    
                }
            }
        },
        async getGrupoAcademico(){
            if (this.programa) {
                try {
                    this.loadingGrupo = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getGrupoAcademico(params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                } catch (error) {
                    
                }
            }
        },
        async getGrupoAdministrativo(){
            if (this.programa) {
                try {
                    this.loadingGrupoAdmin = true
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getGrupo(this.institucion, params)
                    this.gruposAdmin = response
                    this.gruposAdminId = (new Date()).getTime()
                    this.loadingGrupoAdmin = false
                } catch (error) {
                    
                }
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('number', parseInt(this.programa))) {
                this.errorFields.push('programa')
            }
            if(this.grupoAdmin == '' && this.grado == ''){
                if (!this.checkByType ('number', parseInt(this.grupo))) {
                    this.errorFields.push('grupo')
                }
            }
            if(this.grupo == '' && this.grado == ''){
                if (!this.checkByType ('number', parseInt(this.grupoAdmin))) {
                    this.errorFields.push('grupoAdmin')
                }
            }
            if(this.grupo == '' && this.grupoAdmin == ''){
                if (!this.checkByType ('number', parseInt(this.grado))) {
                    this.errorFields.push('grado')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    programa_id: this.programa,
                }
                
                if(this.grupoAdmin != ''){
                    params.grupo_administrativo_id = this.grupoAdmin
                }
                if(this.grupo != ''){
                    params.bloque_academico_id = this.grupo
                }
                if(this.grado != ''){
                    params.grado_id = this.grado
                }
                return params
            } else {
                return null
            }
        },
        getNameArchivo(){
            const vm = this
            vm.instituciones.forEach(i => {
                if(i.id == vm.institucion){
                    vm.institucionName = i.text
                }
            })
            if(vm.grado){
                vm.grados.forEach(g =>{
                    if(g.id === vm.grado){
                        vm.nombreArchivo = vm.institucionName + '_' + g.text
                    }
                })
            }else if(vm.grupo){
                vm.grupos.forEach(g =>{
                    if(g.bloque_academico_id === vm.grupo){
                        vm.nombreArchivo = vm.institucionName + '_' + g.nombre
                    }
                })
            }else if(vm.grupoAdmin){
                vm.gruposAdmin.forEach(g =>{
                    if(g.id === vm.grupoAdmin){
                        vm.nombreArchivo = vm.institucionName + '_' + g.text
                    }
                })
            }
        },
        async getInfoBoletas(tipo){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await reportes.getInfoBoletas(params)
                    // this.users = response
                    this.getNameArchivo()
                    const ciclo = this.ciclosEscolares.find(l => {
                        if(l.id == this.cicloEscolar){
                            return l.text
                        }
                    })
                    const programaText = this.programas.find(l => {
                        if(l.id == this.programa){
                            return l.text
                        }
                    })
                    this.ordenUser(response)
                    this.filtros = {
                        institucion: this.institucion,
                        cicloEscolar: this.cicloEscolar,
                        ciclosEscolares: this.ciclosEscolares,
                        programa: this.programa,
                        programas: this.programas,
                        cicloEscolarName: ciclo,
                        programaName: programaText
                    }
                    loading.close()
                }
                catch{
                    loading.close()
                    
                }
            }
        },
        
        ordenUser(info){
            this.users = info.sort(function(a,b){return a.numero_lista - b.numero_lista})
        }
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.programa = ''
            this.grupo = ''
            this.grado = ''
            this.grupoAdmin = ''
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.getPrograma()
            this.grupo = ''
            this.grado = ''
            this.grupoAdmin = ''
            this.getPeriodoCalculados()
        },
        programa(){
            this.grupo = ''
            this.grado = ''
            this.grupoAdmin = ''
            this.getNivelesAcademicos()
            this.getGrupoAdministrativo()
            this.getGrupoAcademico()
            this.getPeriodoCalificaciones()
            this.getGradoAcademico()
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>
